import 'css-chunksrc/client/pages/workloadPage/toolbar/granularitySelector/styles.scss';export default {
  "granularitySelector": "_granularitySelector_1ynns_1",
  "root": "_root_1ynns_7",
  "input": "_input_1ynns_11",
  "opened": "_opened_1ynns_27",
  "icon": "_icon_1ynns_32",
  "listRoot": "_listRoot_1ynns_44",
  "list": "_list_1ynns_44",
  "option": "_option_1ynns_60",
  "selected": "_selected_1ynns_66"
};